<template>
    <div class="timetable-view-month">
        <b class="float-right">Total: {{ events.length }}</b>

        <div class="table-responsive">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="lesson-number">#</th>
                        <th>Data</th>
                        <th>Ora</th>
                        <th>Nume</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(event, index) in orderedEvents"
                        @click.stop.prevent="
                            clickEvent(event, event._start_time)
                        "
                        v-bind:class="
                            lo.concat(
                                [event._start_time < now ? 'old' : ''],
                                event.custom_css_classes || []
                            )
                        "
                        v-bind:style="lo.merge({}, event.custom_css)"
                    >
                        <th class="lesson-number">{{ index + 1 }}</th>
                        <th>
                            {{
                                event._start_time
                                    | format_date("dddd, D MMMM YYYY")
                            }}
                        </th>
                        <td>
                            {{ event._start_time | format_time }} -
                            {{ event._end_time | format_time }}
                        </td>
                        <td>{{ event.display_title }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import TimetableViewBase from "./TimetableView-Base.vue";

export default {
    extends: TimetableViewBase,

    data() {
        return {
            view: "schedule",
        };
    },

    mounted() {
        console.log("Timetable View Month Component Mounted.");
    },
};
</script>
<style lang="scss">
.timetable-view-month {
    table tbody tr.emergency-exam {
        background: rgba(73, 116, 168, 0.12);

        .lesson-number {
            color: #4f7fb0;
        }
    }
}
</style>
